import { Outlet } from 'react-router-dom'
import { ReactNode } from 'react'

export type UseAiAgentLayoutReturn = {
  children: ReactNode
}

export function useAiAgentLayout(): UseAiAgentLayoutReturn {
  return { children: <Outlet /> }
}
